import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import WidgetContainer from "../containers/WidgetContainer";
import StyleArmor from "./StyleArmor";

class App extends PureComponent {
  render() {
    const { themeTdsId, updateModal } = this.props;

    return (
      <StyleArmor themeTdsId={themeTdsId}>
        <WidgetContainer updateModal={updateModal} />
      </StyleArmor>
    );
  }
}

App.propTypes = {
  updateModal: PropTypes.func
};

export default App;
